import { StatusType } from "@habity/types";
import { FaClock, FaHandshake, FaUserTag } from "react-icons/fa";
import { MdSell } from "react-icons/md";
import { RiPriceTagFill } from "react-icons/ri";
import { TbHeartHandshake } from "react-icons/tb";

export const getStatusIcon = (status?: StatusType) => {
  switch (status) {
    case "soon_for_sale":
      return FaClock;
    case "premarket":
      return MdSell;
    case "seller_claimed":
      return FaUserTag;
    case "premarket":
      return TbHeartHandshake;
    case "private_market":
      return FaHandshake;
    case "for_sale":
      return RiPriceTagFill;
    case "sold":
      return null; // Return null for sold status to display the colored dot instead of an icon

    default:
      return null;
  }
};
